import asyncComponentLoader from "core/loader/loader";
import type {
  AnyProps,
  LoadComponent,
  LoaderDefaultOptions,
} from "core/loader/types";
const loaderDefaultOptions = {
  // no more blinking in your app
  delay: 300, // if your asynchronous process is finished during 300 milliseconds you will not see the loader at all
  minimumLoading: 700, // but if it appears, it will stay for at least 700 milliseconds
};
const EmptyFallback: React.FC = () => null;
const configuredAsyncComponentLoader = (
  loadComponent: LoadComponent,
  FallbackWaiting = EmptyFallback,
  additionalProps: AnyProps = {},
  loaderOptions: LoaderDefaultOptions = loaderDefaultOptions,
) =>
  asyncComponentLoader(
    loadComponent,
    FallbackWaiting,
    additionalProps,
    loaderOptions,
  );

export { loaderDefaultOptions };
export default configuredAsyncComponentLoader;
